import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'shared.PromoBanner.DceDiscountedPromoBanner.title',
    defaultMessage: `Frais d’accompagnement pédagogique offerts 🥳`,
  },
});
